import Error from "@/components/Error";

const Error404 = () => <Error error="404" message="Lo sentimos, la página no se encuentra disponible" />;

export default Error404;
